export default function About() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center mb-14 md:mb-24">
          <div className="relative">
            <div className="relative h-64 md:h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/aefc6ad4b605b6c93ba5923bf0c12678.jpg"
                alt="Urban Connect Professional Electrician"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#f67f19] text-white p-6 md:p-8 rounded-2xl shadow-2xl hidden md:block">
              <div className="text-4xl md:text-5xl font-bold mb-2">15+</div>
              <div className="text-base md:text-lg font-semibold">Years Experience</div>
            </div>
          </div>

          <div>
            <div className="inline-block bg-[#f67f19] text-white px-4 py-2 rounded-full font-bold text-xs md:text-sm mb-4 md:mb-6 uppercase tracking-wide">
              About Us
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#535669] mb-4 md:mb-6 leading-tight">
              Sydney's Most Trusted Electrical Experts
            </h2>
            <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed">
              With over 15 years of experience serving Sydney, Urban Connect has built a reputation for excellence in electrical services. We're not just electricians – we're your trusted partners in keeping your property safe, efficient, and up to code.
            </p>
            <p className="text-sm md:text-base text-gray-600 mb-6 md:mb-8 leading-relaxed">
              Our team of licensed professionals is committed to delivering exceptional service, whether it's an emergency repair, a complete rewiring project, or routine maintenance. We pride ourselves on our same-day service, upfront pricing, and lifetime guarantee on all work.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-[#f67f19] mb-1 md:mb-2">500+</div>
                <div className="text-xs md:text-sm text-gray-600 font-semibold">Happy Clients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-[#f67f19] mb-1 md:mb-2">15+</div>
                <div className="text-xs md:text-sm text-gray-600 font-semibold">Years Experience</div>
              </div>
              <div className="text-center col-span-2 md:col-span-1">
                <div className="text-3xl md:text-4xl font-bold text-[#f67f19] mb-1 md:mb-2">5.0</div>
                <div className="text-xs md:text-sm text-gray-600 font-semibold">Google Rating</div>
              </div>
            </div>

            <button
              onClick={scrollToContact}
              className="w-full md:w-auto bg-[#f67f19] text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-bold text-sm md:text-base hover:bg-[#e06e0a] transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center gap-2"
            >
              <i className="ri-file-list-3-line text-lg md:text-xl"></i>
              Get Your Free Quote
            </button>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="bg-gray-50 rounded-2xl p-6 md:p-12">
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-2xl md:text-4xl font-bold text-[#535669] mb-3 md:mb-4">Why Choose Urban Connect?</h3>
            <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
              We're committed to providing the highest quality electrical services with unmatched customer care
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-shield-check-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold text-[#535669] mb-2">Licensed & Insured</h4>
              <p className="text-xs md:text-sm text-gray-600">Fully licensed electricians with comprehensive insurance coverage</p>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-time-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold text-[#535669] mb-2">Same Day Service</h4>
              <p className="text-xs md:text-sm text-gray-600">Fast response times with same-day service available</p>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-price-tag-3-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold text-[#535669] mb-2">Upfront Pricing</h4>
              <p className="text-xs md:text-sm text-gray-600">Transparent quotes with no hidden fees or surprises</p>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-award-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold text-[#535669] mb-2">Lifetime Guarantee</h4>
              <p className="text-xs md:text-sm text-gray-600">All our work is backed by a lifetime guarantee</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}